import React from 'react';
import { loadStripe } from '@stripe/stripe-js';
import { Elements, ElementsConsumer } from '@stripe/react-stripe-js';

import MobileCartPaymentForm from 'app/components/MobileCartPaymentForm';

class MobileCartStripeForm extends React.Component {
  constructor(props) {
    super(props);
    this.stripePromise = loadStripe(this.props.stripeKey);
  }

  render() {
    return (
      <Elements stripe={this.stripePromise}>
        <ElementsConsumer>
          {({ elements, stripe }) => {
            return (
              <MobileCartPaymentForm
                elements={elements}
                stripe={stripe}
                button={this.props.button}
                processingText={this.props.processingText}
                callback={this.props.callback}
                email={this.props.email}
                errorStyle={this.props.errorStyle}
                accountId={this.props.accountId}
                storyId={this.props.storyId}
                freeMode={this.props.freeMode}
              />
            );
          }}
        </ElementsConsumer>
      </Elements>
    );
  }
}

export default MobileCartStripeForm;
